import React from 'react';
import {
  Drawer,
  useDrawer,
  DrawerHeader,
  DrawerBody,
  FooterButton
} from '@cat-ecom/pcc-components';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import styles from './FooterButtonsMobileDrawer.module.scss';

export interface FooterButtonDrawerProps {
  headerText: string;
  children: React.ReactNode;
  title: string;
  icon: string;
  isLanguageDrawer: string;
}

export const FooterButtonsDrawer = ({
  headerText,
  children,
  title,
  icon,
  isLanguageDrawer
}: Readonly<FooterButtonDrawerProps>) => {
  const { drawerProps, openDrawer, closeDrawer, isDrawerOpen } = useDrawer();

  return (
    <>
      <FooterButton onClick={openDrawer} title={title} icon={icon} />

      {isDrawerOpen && (
        <Drawer
          className={cx(styles['footer-button-mobile-drawer__header'], {
            [styles['footer-button-mobile-drawer__body']]:
              title !== isLanguageDrawer
          })}
          data-testId="footer-button-mobile-drawer"
          orientation="bottom"
          verticalMaxHeight="large"
          onBlDrawerClose={closeDrawer}
          hasBackdrop={false}
          {...drawerProps}
        >
          <DrawerHeader>
            <CatHeading variant="title-sm">{headerText}</CatHeading>
          </DrawerHeader>
          <DrawerBody>{children}</DrawerBody>
        </Drawer>
      )}
    </>
  );
};
